// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_WdzVR {
  position: relative;
  width: 100%;
  height: 100%;
}

.qrWrapper_ouiCe {
  position: relative;
  width: 78% 179.391px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 3px solid #dbdbdb;
  padding: 15px 15px 10px;
  border-radius: 25px;
  flex-direction: column;
  gap: 10px;
  max-width: 200px;
  margin: 0 auto;
  font-size: 28px;

  >div {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;

    svg {
      width: 22px;
      height: 22px;
      min-width: 22px;
      color: var(--black-color);
    }

    b {
      font-size: 76px;
      color: var(--black-color);
      line-height: 10px;
      font-weight: 500;
      letter-spacing: -3px;
    }
  }
}

.qrWrapper_ouiCe:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.editButton_el7mF {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 8px 16px;
  background-color: var(--_10a37f-background);
  border: 1px solid var(--_10a37f-background);
  color: var(--white-color);
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.9;
  transition: opacity 0.2s;
  text-transform: uppercase;
  font-weight: 500;
}

.qrWrapper_ouiCe:hover .editButton_el7mF {
  opacity: 1;
}

.editButton_el7mF:hover {
  opacity: 1;
}


.editorContent_s_P2f {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.closeButton_CVH1v {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--_6-color);
  padding: 0;
  margin: 0;
  line-height: 1;
}

.closeButton_CVH1v:hover {
  color: #333;
}

.editorContent_s_P2f {
  flex: 1 1;
  overflow: hidden;
  padding: 0;
}

.savedConfigsContainer_6Ts4K {
  margin-top: 20px;
  width: 100%;
}

.savedConfigsContainer_6Ts4K h3 {
  font-size: 16px;
  margin-bottom: 10px;
  color: #333;
}

.savedConfigsList_H7m8D {
  
  /* display: flex; */
  display: grid;
  display: none;
  grid-template-columns: 1fr 1fr;
  /* flex-wrap: wrap; */
  gap: 14px;
  margin-top: 10px;
  overflow-y: scroll;
  justify-content: center;

  &::-webkit-scrollbar {
    display: none;
  }
}

.savedConfigItem_ogpK_ {
  align-items: center;
  padding: 5px 5px;
  border: 1px solid #ccc;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  width: min-content;
  filter: grayscale(1);
  margin: 0 auto;
}

.savedConfigItem_ogpK_:hover {
  filter: grayscale(0.5);
}

.selectedConfig_edlHw {
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);
}

.colorPreview_t3VMg {
  width: 70px;
  height: 60px;
  border-radius: 14px;
}


.savedConfigItemText_NKxpt {
  font-size: 12px;
  font-weight: 600;
  color: var(--black-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/QRCodeGenerator/QRCodeGenerator.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;;EAEf;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;;IAEhB;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,yBAAyB;IAC3B;;IAEA;MACE,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;IACtB;EACF;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,2CAA2C;EAC3C,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;;EAEvB;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.qrWrapper {\n  position: relative;\n  width: 78% 179.391px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: transparent;\n  border: 3px solid #dbdbdb;\n  padding: 15px 15px 10px;\n  border-radius: 25px;\n  flex-direction: column;\n  gap: 10px;\n  max-width: 200px;\n  margin: 0 auto;\n  font-size: 28px;\n\n  >div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-weight: 600;\n\n    svg {\n      width: 22px;\n      height: 22px;\n      min-width: 22px;\n      color: var(--black-color);\n    }\n\n    b {\n      font-size: 76px;\n      color: var(--black-color);\n      line-height: 10px;\n      font-weight: 500;\n      letter-spacing: -3px;\n    }\n  }\n}\n\n.qrWrapper:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.editButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 8px 16px;\n  background-color: var(--_10a37f-background);\n  border: 1px solid var(--_10a37f-background);\n  color: var(--white-color);\n  border-radius: 4px;\n  cursor: pointer;\n  opacity: 0.9;\n  transition: opacity 0.2s;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.qrWrapper:hover .editButton {\n  opacity: 1;\n}\n\n.editButton:hover {\n  opacity: 1;\n}\n\n\n.editorContent {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: var(--_6-color);\n  padding: 0;\n  margin: 0;\n  line-height: 1;\n}\n\n.closeButton:hover {\n  color: #333;\n}\n\n.editorContent {\n  flex: 1;\n  overflow: hidden;\n  padding: 0;\n}\n\n.savedConfigsContainer {\n  margin-top: 20px;\n  width: 100%;\n}\n\n.savedConfigsContainer h3 {\n  font-size: 16px;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.savedConfigsList {\n  \n  /* display: flex; */\n  display: grid;\n  display: none;\n  grid-template-columns: 1fr 1fr;\n  /* flex-wrap: wrap; */\n  gap: 14px;\n  margin-top: 10px;\n  overflow-y: scroll;\n  justify-content: center;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.savedConfigItem {\n  align-items: center;\n  padding: 5px 5px;\n  border: 1px solid #ccc;\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 6px;\n  width: min-content;\n  filter: grayscale(1);\n  margin: 0 auto;\n}\n\n.savedConfigItem:hover {\n  filter: grayscale(0.5);\n}\n\n.selectedConfig {\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);\n}\n\n.colorPreview {\n  width: 70px;\n  height: 60px;\n  border-radius: 14px;\n}\n\n\n.savedConfigItemText {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--black-color);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  text-align: center;\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_WdzVR`,
	"qrWrapper": `qrWrapper_ouiCe`,
	"editButton": `editButton_el7mF`,
	"editorContent": `editorContent_s_P2f`,
	"closeButton": `closeButton_CVH1v`,
	"savedConfigsContainer": `savedConfigsContainer_6Ts4K`,
	"savedConfigsList": `savedConfigsList_H7m8D`,
	"savedConfigItem": `savedConfigItem_ogpK_`,
	"selectedConfig": `selectedConfig_edlHw`,
	"colorPreview": `colorPreview_t3VMg`,
	"savedConfigItemText": `savedConfigItemText_NKxpt`
};
export default ___CSS_LOADER_EXPORT___;
